import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import { useTranslation } from 'hooks/use-translation';
import { Props } from './types';

export const PrefixFormItem: FC<Props> = ({ field }) => {
  const prefixInputPlaceholder = useTranslation(
    'projects.phase.import.prefix.placeholder',
  );

  return (
    <Form.Item
      {...field}
      name={[field.name, 'prefix']}
      fieldKey={[field.fieldKey, 'prefix']}
      label={<FormattedMessage id="projects.phase.import.prefix" />}
      tooltip={<FormattedMessage id="projects.phase.import.prefix.help" />}
    >
      <Input autoFocus placeholder={prefixInputPlaceholder} />
    </Form.Item>
  );
};
